import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=9a254aa4&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "./Faq.vue?vue&type=style&index=0&id=9a254aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a254aa4",
  null
  
)

export default component.exports